import { scrollTo } from "./utils";
const $cache = {};

/**
 * Initiates cache
 */
const initCache = () => {
    $cache.window = $(window);
    $cache.backToTopGlobal = $(".back-to-top");
    $cache.backToTopBottomCss = $cache.backToTopGlobal.css("bottom");
    $cache.footer = $("footer");
    $cache.extraBottom = 15;
};

/**
 * Handles the display of the back to top button
 */
const handleBackToTop = () => {
    const windowHeight = $cache.window.height();
    const windowScroll = $cache.window.scrollTop();

    //Show if user scrolled at least half of the viewport height (1.43 represents 70%)
    if (windowScroll > windowHeight/1.43) {
        $cache.backToTopGlobal.removeClass("d-none");

        //Hide if footer is in the viewport
        if ($cache.footer.length && $cache.footer.isInViewport()) {
            $cache.backToTopGlobal.addClass("d-none").removeClass("touched");
        }
    } else {
        if (!$cache.backToTopGlobal.hasClass("d-none")) {
            $cache.backToTopGlobal.addClass("d-none").removeClass("touched");
        }
    }
};

/**
* Updates the bottom of the back to top button
* @param {object} $stickyBar - jQuery object of the sticky bar
* @param {boolean} isSticky - whether the sticky bar is sticky or not
*/
export function updateBottomBackToTop($stickyBar, isSticky) {
    if ($stickyBar && $stickyBar.length) {
        if (!$cache.backToTopGlobal) {
            initCache();
        }

        const backToTopHeight = $cache.backToTopGlobal.outerHeight(true);
        let stickyHeight = $stickyBar.outerHeight(true);

        //Special case for Ardbeg Mobile
        if (backToTopHeight > stickyHeight) {
            stickyHeight = $(".js-add-to-cart-copy").outerHeight(true);
        }

        $cache.backToTopGlobal.css("bottom", isSticky && $stickyBar.hasClass("m-stick")
            ? stickyHeight + $cache.extraBottom
            : $cache.backToTopBottomCss);
    }
}

export default function () {
    initCache();
    handleBackToTop();

    $cache.window.on("scroll", window.debounce(() => {
        handleBackToTop();
    }, 100));

    $cache.backToTopGlobal.on("click", () => {
        $cache.backToTopGlobal.addClass("touched");
        scrollTo(top, 800);
    });
}
